import { AuthenticatedApp } from '@app/authenticatedApp';
import '@app/app.css';
import * as React from 'react';
import '@patternfly/react-core/dist/styles/base.css';
// PatternFly utility classes (pf-v6-u-*) live in a separate stylesheet that
// base.css does not include. Import the full utilities bundle so the pf-v6-u-*
// classes used throughout the app (spacing, text alignment, sizing, etc.) apply.
import '@patternfly/react-styles/css/utilities/_index.css';
import { AuthProvider } from 'react-oidc-context';
import AcceptInvite from '@app/AcceptInvite/AcceptInvite';
import { router } from '@app/routes';
import { ImpersonationProvider } from '../contexts/impersonation/ImpersonationContext';
import { ThemeProvider } from '../contexts/theme/ThemeContext';
import { safeReturnTo } from '../utils/returnTo';

const App: React.FunctionComponent = () => {
  const oidcConfig = {
    authority: 'https://auth.ancalagon.be/realms/Manager/',
    client_id: 'managerfrontend',
    redirect_uri: process.env.REACT_APP_URL,
    post_logout_redirect_uri: process.env.REACT_APP_URL,
    response_type: 'code',
    scope: 'openid profile email',
    onload: 'login-required',
    code_challenge_method: 'S256',
    onSigninCallback: async (authUser) => {
      // Keycloak always returns to the app root; the page the user set out for (an email deep
      // link, say) rides in the sign-in `state`. Restore it through the router, not
      // history.replaceState: the router captured the callback URL when it was created at load,
      // and only its own navigation changes what it renders.
      const returnTo = safeReturnTo(authUser?.state);
      if (returnTo !== null) {
        await router.navigate(returnTo, { replace: true });
      } else {
        window.history.replaceState({}, document.title, window.location.pathname);
      }
      console.log('Callback loaded', authUser.profile.sub);
    },
  };

  const isAcceptInvite = typeof window !== 'undefined' && window.location.pathname === '/accept-invite';

  return (
    // ThemeProvider is auth-free (localStorage-driven) and wraps everything so the
    // saved theme applies to every screen, including the login/unauthenticated views.
    <ThemeProvider>
      <AuthProvider {...oidcConfig}>
        <ImpersonationProvider>{isAcceptInvite ? <AcceptInvite /> : <AuthenticatedApp />}</ImpersonationProvider>
      </AuthProvider>
    </ThemeProvider>
  );
};

export default App;
